define(
    'viewmodels/secured/people/people',[
        "viewmodels/ViewModelNotification",
        "plugins/router",
        "viewmodels/secured/people/context",
        "i19n!i19n/strings",
        "providers/dataprovider",

        // explicitely load these guys in up front to ensure any event handlers are attached and ready to receive.
        "viewmodels/secured/people/tabs/persons/persons",
        "viewmodels/secured/people/tabs/organisations/organisations",
        "viewmodels/secured/people/tabs/teams/teams"       
    ],
    function (ViewModelNotification, router, ctx, i19n, dataProvider, persons, organisations, teams) {

        var personsTabHtml = String.format("<i class='fa fa-user bigger-110'></i> {0} <img class='spinner invisible' src='content/images/spinner.gif' />", i19n.to.people);
        var orgsTabHtml = String.format("<i class='fa fa-building bigger-110'></i> {0} <img class='spinner invisible' src='content/images/spinner.gif' />", i19n.to.organisations);
        var teamsTabHtml = String.format("<i class='fa fa-group bigger-110'></i> {0} <img class='spinner invisible' src='content/images/spinner.gif' />", i19n.to.teams);

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            selectedTab: ko.observable(),
            tabs: {
                persons: new Tab(personsTabHtml, "viewmodels/secured/people/tabs/persons/persons"),
                organisations: new Tab(orgsTabHtml, "viewmodels/secured/people/tabs/organisations/organisations"),
                teams: new Tab(teamsTabHtml, "viewmodels/secured/people/tabs/teams/teams")            
            },

            isInstanceAdmin: ko.observable(false)
        });

        vm.activate = function () {
            var self = this;

            self.notifications([]);

            persons.refresh(true);
            organisations.refresh(true);
            teams.refresh(true);

            self.isInstanceAdmin(vm.session.role == 4 ? true : false);            
        };
        vm.attached = function () {
        };

        vm.activeTabs = ko.observableArray([
            vm.tabs.persons,
            vm.tabs.organisations,
            vm.tabs.teams
        ]);
        vm.close = function () {            
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };              
        vm.tabSelected = function (tab) {            
            return ko.asyncCommand({
                canExecute: function (isExecuting) {
                    return true;
                    //return !isExecuting && !tab.disabled();
                },
                execute: function (data, event, complete) {
                    if (tab == vm.tabs.persons) {
                        persons.refresh(true);
                    }
                    if (tab == vm.tabs.organisations) {
                        organisations.refresh(true);
                    }
                    if (tab == vm.tabs.teams) {
                        teams.refresh(true);
                    }

                    vm.selectedTab(tab);

                    complete();
                }
            });
        };
        vm.selectedTab(vm.tabs.persons);

        return vm;

        function Tab(label, module) {
            var self = this;

            self.label = ko.observable(label);
            self.module = ko.observable(module);
            self.data = ko.observable();
            self.disabled = ko.observable(true);
            self.isBusy = ko.observable(false);

            self.isBusy.subscribe(function (newValue) {
                self.label(newValue === true ? label.replace(" invisible", "") : label);
            });
        }
    });
